import { render, staticRenderFns } from "./IconDuplicateSolid.vue?vue&type=template&id=b6ec2940"
import script from "./IconDuplicateSolid.vue?vue&type=script&lang=js"
export * from "./IconDuplicateSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports